/* ════════════════════════════════════════════════════════════════════════
   hss-mappa.js — DOVE CLICCANO I CLIENTI, E COSA NON GUARDANO MAI.
   ════════════════════════════════════════════════════════════════════════

   ⛔ PERCHE' E' UN FILE A PARTE E NON UN PEZZO DI hss-vigilanza.js.
      La vigilanza ha due cancelli giusti per i GUASTI e fatali per le
      STATISTICHE:
        · TETTO = 10 eventi per sessione
        · e un «niente doppioni»: la stessa chiave non si segnala due volte
      Per un guasto va bene: di un errore JavaScript serve UN esempio, non
      trenta. Ma se i click passassero da li':
        1) cinque click sullo stesso bottone diventerebbero UNO — e quindi
           «cosa cliccano di piu'» non si potrebbe nemmeno calcolare: ogni
           conteggio sarebbe 0 o 1;
        2) i click MANGEREBBERO il tetto dei guasti. Dieci click in
           homepage e la vigilanza e' muta per il resto della sessione: il
           negozio si rompe e il rapporto dice «nessun cliente ha avuto
           problemi». Sarebbe esattamente la paura di Natale («ho paura se
           avra' problemi e non me ne accorgo») prodotta da me.
      Quindi: coda sua, tetto suo, tabella sua, e se questo file muore la
      vigilanza continua a vedere i guasti.

   ⛔ «COSA CLICCANO DI MENO» NON SI MISURA COI CLICK.
      Una fascia con zero click puo' essere zero perche' e' brutta, o zero
      perche' nessuno ci arriva. Senza il denominatore, l'ultima fascia
      della pagina risulta SEMPRE la peggiore e si finisce per cancellare
      una fascia buona solo perche' sta in basso. Percio' qui si misurano
      tre cose, non una:
        · click   → quante volte e' stato premuto
        · vista   → quante volte e' stato VISTO (meta' fascia per 1 secondo)
        · fondo   → fin dove e' arrivato lo scroll
      Il numero che conta e' click/vista. «Visto 900 volte, premuto 2» e'
      una fascia da cambiare; «visto 11 volte» e' una fascia da spostare
      piu' su, che e' una correzione completamente diversa.

   ⚠️ NON RACCOGLIE NIENTE DI PERSONALE: nessun indirizzo digitato, nessun
      contenuto di campo, nessuna coordinata del mouse (aggregata fra
      telefoni e monitor non vuol dire nulla), nessun nome. Solo: quale
      fascia del tema, che ruolo ha l'elemento, l'etichetta che si legge
      sopra, e il tipo di pagina.

   ⚠️ SE QUALCOSA VA STORTO QUI, IL NEGOZIO NON SE NE DEVE ACCORGERE:
      tutto dentro try/catch, invio con sendBeacon, nessun blocco.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  try {
    var DOVE = 'https://crm.hobbyshopsolution.com/api/mappa/eventi';

    // ⚠️ Tetti pensati per le statistiche, non per i guasti: una sessione
    //    vera clicca 10-40 volte. 150 lascia respiro a chi gira molto e
    //    mette comunque un soffitto a un eventuale ciclo impazzito.
    var TETTO_SESSIONE = 150;
    var LOTTO = 12;
    var RITARDO = 4000;

    if (window.__hssMappaPresa) return;        // una sola volta per pagina
    window.__hssMappaPresa = 1;

    // ─────────── chi sono: sessione e ramo della prova
    // ⚠️ La sessione e' la stessa della vigilanza: cosi' un guasto e un
    //    percorso di click si possono mettere accanto senza inventare un
    //    secondo identificativo.
    var sessione = '';
    try {
      sessione = sessionStorage.getItem('hss_vig_sess') || '';
      if (!sessione) {
        sessione = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem('hss_vig_sess', sessione);
      }
    } catch (e) { sessione = 's-senza-memoria'; }

    // ⚠️ Il ramo della prova lo decide il blocco INLINE in theme.liquid,
    //    prima che la pagina si disegni: se lo decidessi qui (file defer)
    //    una variante fatta in CSS si vedrebbe cambiare sotto gli occhi
    //    del cliente. Qui lo leggo soltanto.
    var ramo = '';
    try { ramo = document.documentElement.getAttribute('data-hss-ramo') || ''; } catch (e) {}

    var via = '';
    try { via = (location.pathname || '/').slice(0, 300); } catch (e) { via = '/'; }
    // ⛔ IL PREFISSO DI MERCATO MANDAVA LE SCHEDE PRODOTTO IN «ALTRO». Shopify
    //    Markets serve lo stesso prodotto anche su `/it-es/products/...`,
    //    `/de-gr/...`, `/fr-fr/...`: con `indexOf(...) === 0` il confronto
    //    partiva dal primo carattere e quelle pagine non combaciavano con
    //    niente. Misurato il 19/10 su 24 ore: delle righe su un URL
    //    `/products/` finite in «altro», 222 su 222 erano localizzate; delle
    //    1.750 classificate bene, ZERO lo era. Nessuna sovrapposizione, quindi
    //    non e' un caso limite: e' la regola.
    // ⚠️ Perche' conta. L'errore sbaglia SEMPRE NELLO STESSO VERSO — toglie
    //    sessioni alla pagina prodotto e le butta in un mucchio senza nome —
    //    quindi non si media via: si accumula e decide. Ogni lettura «dove
    //    cliccano i clienti» divisa per tipo di pagina ne era storta.
    // ⚠️ E la scheda prodotto si raggiunge anche da dentro una collezione
    //    (`/collections/all/products/x`): il modello reso e' quello del
    //    prodotto, non della collezione, quindi il prodotto si cerca DOVUNQUE
    //    nel percorso e si guarda PRIMA della collezione.
    function cheRoba(p) {
      p = String(p || '');
      // Via il prefisso di mercato: `/it-es/...` e anche la forma con la sola
      // lingua `/es/...`, che Shopify usa quando il paese e' uno solo.
      p = p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/, '');
      if (p === '/' || p === '') return 'home';
      if (/\/products\//.test(p)) return 'prodotto';
      if (p.indexOf('/collections/') === 0) return 'collezione';
      if (p.indexOf('/cart') === 0) return 'carrello';
      if (p.indexOf('/pages/') === 0) return 'pagina';
      if (p.indexOf('/blogs/') === 0) return 'blog';
      if (p.indexOf('/search') === 0) return 'ricerca';
      if (p.indexOf('/account') === 0) return 'account';
      return 'altro';
    }
    var tipoPagina = cheRoba(via);
    var tema = '';
    try { tema = String((window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || ''); } catch (e) {}
    var mobile = false;
    try { mobile = window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 750; } catch (e) {}

    // ─────────── coda e tetto (tutti suoi, non quelli della vigilanza)
    var coda = [], timer = null, chiuso = false;
    function letto() {
      try { return parseInt(sessionStorage.getItem('hss_mappa_n') || '0', 10) || 0; } catch (e) { return 0; }
    }
    function scrivi(n) { try { sessionStorage.setItem('hss_mappa_n', String(n)); } catch (e) {} }

    function spedisci() {
      try {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!coda.length) return;
        var corpo = JSON.stringify({
          sessione: sessione, mobile: mobile, larghezza: window.innerWidth,
          tema: tema, ramo: ramo, eventi: coda.splice(0, 40)
        });
        var andata = false;
        if (navigator.sendBeacon) {
          try { andata = navigator.sendBeacon(DOVE, new Blob([corpo], { type: 'text/plain;charset=UTF-8' })); } catch (e) {}
        }
        if (!andata && window.fetch) {
          try {
            window.fetch(DOVE, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: corpo, keepalive: true, mode: 'cors', credentials: 'omit'
            })['catch'](function () {});
          } catch (e) {}
        }
      } catch (e) {}
    }

    function nota(genere, sezione, ruolo, etichetta, posizione, bersaglio, numero) {
      try {
        if (chiuso) return;
        var n = letto();
        if (n >= TETTO_SESSIONE) return;
        scrivi(n + 1);
        coda.push({
          genere: genere, pagina: via, tipo_pagina: tipoPagina,
          sezione: sezione ? String(sezione).slice(0, 80) : null,
          ruolo: ruolo ? String(ruolo).slice(0, 40) : null,
          etichetta: etichetta ? String(etichetta).replace(/\s+/g, ' ').trim().slice(0, 120) : null,
          posizione: (typeof posizione === 'number' && isFinite(posizione)) ? posizione : null,
          bersaglio: bersaglio ? String(bersaglio).slice(0, 200) : null,
          numero: (typeof numero === 'number' && isFinite(numero)) ? Math.round(numero) : null
        });
        if (coda.length >= LOTTO) spedisci();
        else if (!timer) timer = setTimeout(spedisci, RITARDO);
      } catch (e) {}
    }

    // ═══════════ CHI E' L'ELEMENTO CHE HANNO PREMUTO ═══════════
    //
    // ⛔ NON USO IL PERCORSO CSS (div > div:nth-child(3) > a). Sembra
    //    preciso ed e' inutile: cambia a ogni modifica del tema, quindi i
    //    dati di ieri non si sommano a quelli di oggi e dopo una settimana
    //    il rapporto e' un elenco di stringhe tutte diverse con conteggio 1.
    //    Uso invece la FASCIA del tema (che ha un nome stabile scelto da
    //    noi) + il RUOLO + l'ETICHETTA che il cliente legge.
    function fascia(el) {
      try {
        var s = el.closest ? el.closest('[id^="shopify-section-"]') : null;
        if (s && s.id) {
          var t = s.getAttribute('data-section-type') || '';
          // ⛔ VIA IL NUMERO DAL NOME, SEMPRE. Shopify premette al nome della
          //    fascia l'id del template OPPURE quello del gruppo di sezioni:
          //    `template--1234__hss_home` ma anche `sections--5678__hss_header`.
          //    Il primo lo toglievo, il secondo no — e il secondo e' proprio
          //    quello della TESTATA e del FONDO PAGINA, cioe' le due fasce
          //    presenti su OGNI pagina del negozio.
          // ⚠️ Quel numero cambia se il gruppo viene rifatto: da quel giorno
          //    la «testata» di ieri e quella di oggi diventerebbero due righe
          //    diverse nel rapporto, e il conto della fascia piu' vista del
          //    negozio ripartirebbe da zero senza che nulla segnali niente.
          //    E' lo stesso difetto che il commento qui sopra dice di evitare:
          //    l'avevo evitato solo a meta'. Misurato sul vivo il 19/10.
          var nome = s.id.replace(/^shopify-section-/, '').replace(/^(template|sections)--\d+__/, '');
          return t ? nome + ' (' + t + ')' : nome;
        }
        if (el.closest) {
          if (el.closest('header, .header')) return 'testata';
          if (el.closest('footer, .footer')) return 'fondo-pagina';
          if (el.closest('cart-drawer, .cart-drawer')) return 'tendina-carrello';
          if (el.closest('.hss-ricerca, [data-hss-search]')) return 'ricerca';
        }
      } catch (e) {}
      return 'fuori-fascia';
    }

    function ruoloDi(el) {
      try {
        var tag = (el.tagName || '').toLowerCase();
        var href = (el.getAttribute && el.getAttribute('href')) || '';
        var name = (el.getAttribute && el.getAttribute('name')) || '';
        var type = (el.getAttribute && el.getAttribute('type')) || '';
        if (name === 'add' || /add-to-cart/i.test(el.className || '')) return 'bottone-aggiungi';
        if (/\/cart\/change/.test(href) || /quantity=0/.test(href)) return 'rimuovi-dal-carrello';
        if (/\/checkout/.test(href) || name === 'checkout') return 'vai-al-pagamento';
        if (/\/cart/.test(href)) return 'vai-al-carrello';
        if (/\/products\//.test(href)) return 'scheda-prodotto';
        if (/\/collections\//.test(href)) return 'link-collezione';
        if (/\/pages\//.test(href)) return 'link-pagina';
        if (/^(tel:|mailto:)/.test(href)) return 'contatto';
        if (/^https?:/.test(href) && href.indexOf(location.host) === -1) return 'link-esterno';
        if (tag === 'summary' || (el.getAttribute && el.getAttribute('aria-expanded') !== null)) return 'apri-chiudi';
        if (tag === 'button' || type === 'submit') return 'bottone';
        if (tag === 'a') return 'link';
        if (tag === 'img') return 'immagine';
        if (tag === 'input' || tag === 'select' || tag === 'textarea') return 'campo';
      } catch (e) {}
      return 'altro';
    }

    // ⚠️ L'etichetta di una scheda prodotto NON deve essere il titolo del
    //    prodotto: sono migliaia di valori diversi e il rapporto diventa
    //    illeggibile (tutti i conteggi a 1). Per le schede uso la POSIZIONE
    //    («scheda #3»), che e' la domanda vera: cliccano solo le prime due?
    //    Il titolo lo metto da parte in `bersaglio`, cosi' resta possibile
    //    anche l'altro rapporto senza rifare la raccolta.
    function etichettaDi(el, ruolo) {
      try {
        if (ruolo === 'scheda-prodotto') return null;
        var t = (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) t = (el.getAttribute && (el.getAttribute('aria-label') || el.getAttribute('alt') || el.getAttribute('title'))) || '';
        // ⛔ 14 click su /cart (12 da telefono) finivano senza nome NE'
        //    destinazione: un bottone con la sola icona. Non si poteva dire
        //    nemmeno se funziona. ✔ Qui NON invento un'etichetta: registro
        //    l'indizio che c'e', marcato «(senza nome)» per non confonderlo
        //    con il testo che legge il cliente.
        if (!t) {
          var ind = '';
          try {
            ind = (el.getAttribute('name') || el.getAttribute('data-action') ||
                   el.getAttribute('data-hss') || el.getAttribute('value') || '').trim();
            if (!ind) {
              var cl = String(el.className || '').replace(/\s+/g, ' ').trim();
              if (cl) ind = 'classe:' + cl.split(' ').slice(0, 2).join('.');
            }
            if (!ind) ind = (el.tagName || '').toLowerCase();
          } catch (e) {}
          t = ind ? '(senza nome) ' + ind : '';
        }
        return t.slice(0, 120);
      } catch (e) { return null; }
    }

    // ⛔ PRIMA confrontavo i NODI: elenco unico per href tenendo la PRIMA
    //    ancora (l'immagine) e poi `viste[k] === el`. Se il cliente premeva il
    //    TITOLO — seconda ancora con lo stesso href, SORELLA e non figlia
    //    dell'immagine — nessun confronto combaciava: 82 click su 131 senza
    //    posizione, cioe' il 63% proprio sulla domanda «cliccano solo le
    //    prime due?». E la chiave grezza contava `?variant=` come un altro
    //    prodotto: di qui le posizioni 125 e 248 su pagine da 22 prodotti.
    // ✔ ORA confronto gli HANDLE, non i nodi.
    function handleDi(h) {
      try {
        var m = String(h || '').match(/\/products\/([^?#]+)/);
        return m ? decodeURIComponent(m[1]) : '';
      } catch (e) { return ''; }
    }

    function posizioneFra(el, ruolo) {
      try {
        if (ruolo !== 'scheda-prodotto') return null;
        var mio = handleDi((el.getAttribute && el.getAttribute('href')) || '');
        if (!mio && el.querySelector) {
          var dentro = el.querySelector('a[href*="/products/"]');
          if (dentro) mio = handleDi(dentro.getAttribute('href'));
        }
        if (!mio && el.closest) {
          var box = el.closest('.card, .product-card, .hbsr-card, li, .grid__item');
          var a = box && box.querySelector ? box.querySelector('a[href*="/products/"]') : null;
          if (a) mio = handleDi(a.getAttribute('href'));
        }
        if (!mio) return null;
        var s = el.closest('[id^="shopify-section-"]') || document.body;
        var tutte = s.querySelectorAll('a[href*="/products/"]');
        var ordine = [], gia = {};
        for (var i = 0; i < tutte.length; i++) {
          var h = handleDi(tutte[i].getAttribute('href'));
          if (!h || gia[h]) continue;           // l'immagine e il titolo sono lo stesso prodotto
          gia[h] = 1; ordine.push(h);
        }
        for (var k = 0; k < ordine.length; k++) {
          if (ordine[k] === mio) return k + 1;
        }
      } catch (e) {}
      return null;
    }

    // ═══════════ 1. I CLICK ═══════════
    // ⚠️ Un listener solo, sul documento, e salgo al primo antenato che
    //    «vuol dire qualcosa»: senza questo, un click su un'icona dentro un
    //    bottone dentro un link conterebbe tre volte.
    var ultimo = { chi: null, quando: 0 };
    document.addEventListener('click', function (ev) {
      try {
        var t = ev.target;
        if (!t || !t.closest) return;
        var el = t.closest('a, button, summary, [role="button"], input[type="submit"], label, .card, .product-card');
        if (!el) return;

        // ⚠️ Lo stesso elemento premuto due volte in 400 ms e' un doppio
        //    invio del browser, non due intenzioni del cliente.
        var ora = Date.now();
        if (ultimo.chi === el && (ora - ultimo.quando) < 400) return;
        ultimo = { chi: el, quando: ora };

        var ruolo = ruoloDi(el);
        var href = (el.getAttribute && el.getAttribute('href')) || '';
        var handle = '';
        try {
          var m = href.match(/\/products\/([^?#]+)/);
          if (m) handle = decodeURIComponent(m[1]).slice(0, 120);
        } catch (e) {}

        nota('click', fascia(el), ruolo, etichettaDi(el, ruolo), posizioneFra(el, ruolo), handle || null, null);
      } catch (e) {}
    }, true);

    // ═══════════ 2. LE VISTE — il denominatore ═══════════
    // ⛔ Senza questo, «cosa cliccano di meno» e' una classifica della
    //    posizione in pagina, non della qualita' della fascia.
    //
    // ⛔ META' DELLA FASCIA E' LA MISURA SBAGLIATA, E SBAGLIA SEMPRE NELLO
    //    STESSO VERSO. Chiedevo `intersectionRatio >= 0.5`: meta' della
    //    FASCIA dentro lo schermo. Ma una scheda prodotto e' alta ~6.300 px e
    //    lo schermo di un telefono 844: quella fascia non puo' arrivare al 50%
    //    nemmeno riempiendo tutto il vetro — il massimo che toccava era 13%.
    //    Risultato misurato sul vivo il 19/10: `main` 46 viste e 157 click (il
    //    341%), `hss_home` e `cart-items` ZERO viste con i click dentro.
    // ⚠️ Non e' rumore che si media via: mancano le viste SOLO alle fasce
    //    alte, cioe' il corpo della pagina, cioe' quelle che contano. Il
    //    rapporto click/viste le faceva sembrare irresistibili e le fasce
    //    corte (testata, fondo) le faceva sembrare inutili. Avrei riscritto
    //    la fascia sbagliata, convinto dai numeri.
    // ✅ La domanda giusta non e' «quanta fascia si vede» ma «quanto schermo
    //    occupa»: vale come vista quando la parte visibile copre almeno meta'
    //    dello SCHERMO, oppure meta' della fascia se la fascia e' piu' bassa
    //    dello schermo. Cosi' la soglia e' la stessa per una fascia da 200 px
    //    e per una da 20.000.
    // ⚠️ E i gradini dell'osservatore vanno infittiti: con [0, 0.5, 1] una
    //    fascia alta attraversava tutto lo schermo senza far scattare
    //    nessuna chiamata, perche' non superava mai il gradino 0.5.
    //
    // ⛔ UNA FASCIA CON `display:contents` NON HA UN RIQUADRO: 0×0. La pagina
    //    carrello ha `cart-items` e `cart-footer` cosi': sono involucri, a
    //    disegnare sono i figli. `getBoundingClientRect()` risponde 0×0 e
    //    l'osservatore non puo' misurare area su un'area che non esiste.
    //    Col vecchio conto facevano 0 viste; col conto nuovo `serve` viene 0 e
    //    il cancello `serve > 0` — che ho scritto io per non contare come vista
    //    un elemento davvero invisibile — le butta fuori una seconda volta.
    //    Misurato sul vivo il 19/10: `cart-items` 3 click e ZERO viste.
    // ⚠️ E' la TERZA volta che lo stesso difetto torna con un vestito nuovo:
    //    manca il denominatore, manca solo alle fasce che contengono il corpo
    //    della pagina, e sbaglia sempre nello stesso verso. Non l'ho trovato
    //    rileggendo il codice: l'ha trovato `_mappa_impossibili.cjs` chiedendo
    //    come fa una fascia ad avere click senza viste.
    // ✅ Se l'involucro non ha riquadro, osservo i FIGLI che ce l'hanno e
    //    attribuisco la vista alla fascia che li contiene. Il cancello
    //    `serve > 0` resta, ma ora guarda solo riquadri che esistono.
    try {
      if (window.IntersectionObserver && window.Map) {
        var segnate = {}, attese = {};
        var padre = new Map();                  // elemento osservato → fascia
        var PASSI = [];
        for (var gp = 0; gp <= 20; gp++) PASSI.push(gp / 20);
        var oss = new IntersectionObserver(function (voci) {
          voci.forEach(function (v) {
            var sez = padre.get(v.target);
            if (!sez) return;
            var id = sez.id || '';
            if (!id || segnate[id]) return;
            // ⚠️ `rootBounds` e' null in qualche browser: ricado su innerHeight.
            var schermo = (v.rootBounds && v.rootBounds.height) || window.innerHeight || 0;
            var altaFascia = (v.boundingClientRect && v.boundingClientRect.height) || 0;
            var vistaOra = (v.intersectionRect && v.intersectionRect.height) || 0;
            var serve = Math.min(schermo, altaFascia) * 0.5;
            var atteso = attese[id];
            if (v.isIntersecting && serve > 0 && vistaOra >= serve) {
              // ⚠️ Un secondo di permanenza: una fascia attraversata in
              //    volata con lo scroll non e' «vista».
              if (atteso) return;
              attese[id] = { el: v.target, t: setTimeout(function () {
                attese[id] = 0;
                if (segnate[id]) return;
                segnate[id] = 1;
                nota('vista', fascia(sez), null, null, null, null, null);
              }, 1000) };
              // ⚠️ Annullo SOLO se esce di schermo l'elemento che ha armato
              //    l'attesa: con piu' figli osservati per la stessa fascia, un
              //    fratello che esce non deve spegnere il conto dell'altro.
            } else if (atteso && atteso.el === v.target) {
              clearTimeout(atteso.t);
              attese[id] = 0;
            }
          });
        }, { threshold: PASSI });
        // ⛔ QUANTO SCENDERE NON E' UN NUMERO DA INDOVINARE: VA MISURATO.
        //    Avevo scritto 3 livelli a occhio. Misurato sul vivo il 19/10, la
        //    catena di `cart-footer` e' tutta senza riquadro per QUATTRO
        //    livelli (fascia → .gradient → .page-width → .cart__footer) e i
        //    primi riquadri veri stanno al quinto: col tetto a 3 non osservavo
        //    nulla e la fascia restava senza denominatore — lo stesso difetto
        //    appena corretto, rientrato dalla finestra per via di una costante
        //    scelta male. Tetto a 6, con un bilancio di bersagli per non
        //    mettersi a osservare mezza pagina.
        var MAX_GIU = 6, MAX_BERSAGLI = 24;
        var bersagli = function (el, prof, conto) {
          var fuori = [];
          try {
            var r = el.getBoundingClientRect();
            if (r.width > 0 && r.height > 0) return [el];
            if (prof >= MAX_GIU) return fuori;
            for (var k = 0; k < el.children.length; k++) {
              if (conto.n >= MAX_BERSAGLI) break;
              var giu = bersagli(el.children[k], prof + 1, conto);
              for (var j = 0; j < giu.length; j++) { fuori.push(giu[j]); conto.n++; }
            }
          } catch (e) {}
          return fuori;
        };
        var fasce = document.querySelectorAll('[id^="shopify-section-"]');
        for (var i = 0; i < fasce.length; i++) {
          var quali = bersagli(fasce[i], 0, { n: 0 });
          for (var q = 0; q < quali.length; q++) {
            padre.set(quali[q], fasce[i]);
            oss.observe(quali[q]);
          }
        }
      }
    } catch (e) {}

    // ═══════════ 3. FIN DOVE ARRIVANO ═══════════
    // ⚠️ Una fascia «mai cliccata» che sta al 90% della pagina, dove arriva
    //    il 12% dei clienti, non va riscritta: va spostata piu' su.
    var fondoMax = 0;
    try {
      var misura = function () {
        try {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h <= 0) { fondoMax = 100; return; }
          var q = Math.round(((window.pageYOffset || document.documentElement.scrollTop) / h) * 100);
          if (q > fondoMax) fondoMax = Math.min(100, q);
        } catch (e) {}
      };
      var attesa = null;
      window.addEventListener('scroll', function () {
        if (attesa) return;
        attesa = setTimeout(function () { attesa = null; misura(); }, 300);
      }, { passive: true });
      misura();
    } catch (e) {}

    // ═══════════ 4. CHIUSURA ═══════════
    // ⚠️ UNA SOLA riga «fondo» per pagina. I tre agganci qui sotto sparano
    //    spesso tutti e tre (pagehide, beforeunload e visibilitychange si
    //    accavallano a seconda del browser): senza questo guardiano la
    //    profondita' di scroll risulterebbe contata due o tre volte, e il
    //    denominatore delle viste sarebbe gonfiato solo su certi browser —
    //    cioe' un errore che si vede solo confrontando telefono e computer.
    //
    // ⚠️ E NON CHIUDO LA RACCOLTA QUI. Il primo giro metteva `chiuso = true`
    //    dentro questa funzione: ma su telefono `visibilitychange` scatta
    //    anche quando il cliente cambia scheda per un attimo e poi TORNA —
    //    e da quel momento ogni suo click sarebbe stato buttato. Si perdeva
    //    la seconda meta' delle sessioni mobili senza che nulla segnalasse
    //    niente. Qui si manda il fondo e si tiene aperto.
    //
    // ⛔ E IL PREZZO DI QUEL «UNA VOLTA SOLA» L'HO MISURATO, 19/10. Scrivevo
    //    qui sopra che «chi torna e scende piu' giu' resta contato alla
    //    profondita' di prima» come se fosse un dettaglio. Non lo e':
    //    `visibilitychange` scatta appena il cliente guarda una notifica,
    //    quindi la riga partiva a scroll 0 PRIMA che la pagina fosse letta.
    //    Su 98 sessioni che dichiaravano «0%», 14 avevano poi visto fasce che
    //    stanno in fondo alla pagina — le avevano lette, e il numero diceva
    //    che non si erano mosse. ⚠️ L'errore andava sempre nello stesso verso
    //    (profondita' sottostimata), ed e' il numero su cui si decide se una
    //    fascia va riscritta o solo spostata piu' su.
    // ✅ Ora una riga nuova parte SE la profondita' e' cresciuta di almeno 5
    //    punti dall'ultima mandata. Il rapporto prende il MASSIMO per pagina
    //    (sessione + indirizzo), non la media delle righe: cosi' le righe in
    //    piu' non abbassano niente e l'ultima parola e' di chi e' scesO piu' giu'.
    var fondoMandato = -1;
    function addio() {
      try {
        if (fondoMandato < 0 || fondoMax >= fondoMandato + 5) {
          fondoMandato = fondoMax;
          nota('fondo', null, null, null, null, null, fondoMax);
        }
        spedisci();
      } catch (e) {}
    }
    window.addEventListener('pagehide', addio);
    window.addEventListener('beforeunload', addio);
    document.addEventListener('visibilitychange', function () {
      try { if (document.visibilityState === 'hidden') addio(); } catch (e) {}
    });
  } catch (e) { /* ⚠️ il negozio non si accorge di niente */ }
})();
